module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AE-b5809ad30cd23b048118db0ae5793c04.png";